module.exports = __webpack_public_path__ + "static/media/action-grocery-list.159cd330.svg";